import MetasVenta from 'akasia-components/administradores/MetasVenta/MetasVenta';
import ConfirmarEmail from 'akasia-components/authentication/simple/ConfirmarEmail';
import SimpleForgetPassword from 'akasia-components/authentication/simple/ForgetPassword';
import SimpleLogin from 'akasia-components/authentication/simple/Login';
import SimpleLogout from 'akasia-components/authentication/simple/Logout';
import SimplePasswordReset from 'akasia-components/authentication/simple/PasswordReset';
import Clientes from 'akasia-components/cliente/Clientes';
import ClientesInfoIncompleta from 'akasia-components/cliente/ClientesInfoIncompleta';
import ConctactosDuplicados from 'akasia-components/cliente/ConctactosDuplicados';
import DetallesCliente from 'akasia-components/cliente/DetallesCliente';
import NuevoCliente from 'akasia-components/cliente/NuevoCliente';
import Pagos from 'akasia-components/conciliacion/pagos/Pagos';
import ConciliarFacturas from 'akasia-components/conciliacion/conciliar/ConciliarFacturas';
import DashGeneral from 'akasia-components/dashboards/general';
import AkasiaPosDashboard from 'akasia-components/akasia-pos/dashboard/AkasiaPosDashboard';

import FacturaDocumentosEcuador from 'akasia-components/factura-ecuador/FacturaDocumentosEcuador';
import FacturaDocumentosGuatemala from 'akasia-components/factura-guatemala/FacturaDocumentosGuatemala';

import PlanesFacturacionBolivia from 'akasia-components/factura-Bolivia/PlanesFacturacionBolivia';
import PlanesFacturacionPanama from 'akasia-components/factura-Panama/PlanesFacturacionPanama';
import PlanesFacturacionPeru from 'akasia-components/factura-Peru/PlanesFacturacionPeru';
import PlanesFacturacionCostaRica from 'akasia-components/factura-costarica/PlanesFacturacionCostaRica';
import PlanesFacturacionElSalvador from 'akasia-components/factura-elsalvador/PlanesFacturacionElSalvador';

import DetallesLicencia from 'akasia-components/licencia/DetallesLicencia';
import EditarUsuarioNubeAkasia from 'akasia-components/licencia/EditarUsuarioNubeAkasia';
import Licencias from 'akasia-components/licencia/Licencias';
import LicenciasInfoIncompleta from 'akasia-components/licencia/LicenciasInfoIncompleta';
import NuevaLicencia from 'akasia-components/licencia/NuevaLicencia';
import NuevaAppComandas from 'akasia-components/licencia/NuevaLicenciaAppComandas';
import NuevaLicenciaCaja from 'akasia-components/licencia/NuevaLicenciaCaja';
import NuevaLicenciaNube from 'akasia-components/licencia/NuevaLicenciaNube';
import NuevaLicenciaServidor from 'akasia-components/licencia/NuevaLicenciaServidor';
import NuevaLicenciaAkasiaPOS from 'akasia-components/licencia/NuevaLicenciaAkasiaPOS';
import NuevoUsuarioNubeAkasia from 'akasia-components/licencia/NuevoUsuarioNubeAkasia';
import UsuariosNubeAkasia from 'akasia-components/licencia/UsuariosNubeAkasia';
import LogServicios from 'akasia-components/logs/LogServicios';
import Orders from 'akasia-components/orden/CatalogoOrdenes';
import OrderDetails from 'akasia-components/orden/DetalleOrden';
import NuevaOrden from 'akasia-components/orden/NuevaOrden';
import DetallesPoliza from 'akasia-components/poliza/DetallesPoliza';
import RecargasTaecel from 'akasia-components/recargas-taecel/RecargasTaecel';
import CatalogoTicketSoporte from 'akasia-components/soporte-tecnico/CatalogoTicketSoporte';
import DetallesSoporte from 'akasia-components/soporte-tecnico/detalles-soporte/ContactDetails';

import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import useToken from 'hooks/useToken';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';

import AjustesFacturacion from 'akasia-components/Contabilidad/Ajustes/AjustesContabilidad';
import ModalDatosFiscales from 'akasia-components/Contabilidad/Ajustes/ModalDatosFiscales';
import ActivoFijo from 'akasia-components/Contabilidad/activo-fijo/ActivoFijo';
import RegistroActivoFijo from 'akasia-components/Contabilidad/activo-fijo/RegistroActivoFijo';
//import SupportDesk from 'akasia-components/dashboards/support-desk';
import Distribuidores from 'akasia-components/distribuidor/Distribuidores';
import Contacts from 'akasia-components/leads/Contacts';
import Notifications from 'akasia-components/notification/NotificationsPage';
import Profile from 'akasia-components/profile/Profile';
import MainLayout from 'layouts/MainLayout';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Route, Routes } from 'react-router-dom';
import Empleados from '../akasia-components/Contabilidad/empleados/Empleados';

import DetalleEmpleado from '../akasia-components/Contabilidad/empleados/DetalleEmpleado';
import RegistroEmpleado from '../akasia-components/Contabilidad/empleados/RegistroEmpleado';

import Cuentas from 'akasia-components/Contabilidad/cuentas/Cuentas';

import Productos from 'akasia-components/productos/Productos';
import AgregarProductos from 'akasia-components/productos/AgregarProducto';
import DetalleProducto from 'akasia-components/productos/DetalleProducto';

import Gastos from 'akasia-components/Contabilidad/gastos/Gastos';
import CargarXML from 'akasia-components/Contabilidad/facturacion/CargarXML';
import Facturas from 'akasia-components/Contabilidad/facturas/Facturas';
import FormularioFactura from 'akasia-components/Contabilidad/facturas/FormularioFactura';

import PagosEmitidos from 'akasia-components/Contabilidad/facturacion/pagos-emitidos/PagosEmitidos';
import VisualizacionFacturasPE from 'akasia-components/Contabilidad/facturacion/pagos-emitidos/VisualizacionFacturasPagosEmitidos';

import Emitidas from '../akasia-components/Contabilidad/facturacion/facturas-emitidas/Emitidas';
import Recibidas from '../akasia-components/Contabilidad/facturacion/facturas-recibidas/Recibidas';
import VisualizacionFacturasEmitidas from '../akasia-components/Contabilidad/facturacion/facturas-emitidas/VisualizacionFacturasEmitidas';
import VisualizacionFacturasRecibidas from '../akasia-components/Contabilidad/facturacion/facturas-recibidas/VisualizacionFacturasRecibidas';
import Nominas from '../akasia-components/Contabilidad/facturacion/nomina/Nomina';


import PagosRecibidos from 'akasia-components/Contabilidad/facturacion/pagosrecibidos/pagosrecibidos';
import VisualizacionFacturasPR from 'akasia-components/Contabilidad/facturacion/pagosrecibidos/VisualizacionFacturasPagosRecibidos';
import AdministradoresReporteLeads from 'akasia-components/administradores/AdministradoresReporteLeads';
import AdministradoresReporteVentas from 'akasia-components/administradores/AdministradoresReporteVentas';
import Impuestos from '../akasia-components/Contabilidad/impuestos/Impuestos';
import CalendarioEditorial from '../akasia-components/marketing/calendario-editorial/CalendarioEditorial';
import VacacionesPendientes from '../akasia-components/Contabilidad/empleados/VacacionesPendientes';
import MarketingDashboard from '../akasia-components/marketing/dashboard/MarketingDashboard';



const FalconRoutes = () => {


    const { token } = useToken();

    if (!token) {
        return (
            <Section className="py-0">
                <Row className="flex-center min-vh-100 py-6">
                    <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
                        <Logo />
                        <Card>
                            <Card.Body className="p-4 p-sm-5">
                                <SimpleLogin />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Section>
        );
    }




    return (
        <Routes>

            {/*- ------------- Authentication ---------------------------  */}

            {/*- ------------- simple ---------------------------  */}
            <Route element={<AuthSimpleLayout />}>
                <Route path="authentication/simple/login" element={<SimpleLogin />} />

                <Route path="authentication/simple/logout" element={<SimpleLogout />} />
                <Route
                    path="authentication/simple/forgot-password"
                    element={<SimpleForgetPassword />}
                />
                <Route
                    path="authentication/simple/reset-password"
                    element={<SimplePasswordReset />}
                />
                <Route
                    path="authentication/simple/confirm-mail"
                    element={<ConfirmarEmail />}
                />
            </Route>


            {/* //--- MainLayout Starts  */}
            <Route element={<MainLayout />}>

                {/*Dashboard*/}
                <Route path="/" element={<DashGeneral />} />

                <Route path="/dashboard/support-desk" element={<CatalogoTicketSoporte />} />
                <Route path="/dashboard/akasia-pos" element={<AkasiaPosDashboard />} />

                {/*Administradores*/}
                <Route path="/administradores/reporte-ventas" element={<AdministradoresReporteVentas />} />
                <Route path="/administradores/reporte-seguimiento-leads" element={<AdministradoresReporteLeads />} />

                {/*Contactos*/}
                <Route path="/contactos" element={<Contacts />} />

                {/*Notificaciones*/}
                <Route path="/notificaciones" element={<Notifications />} />

                {/*Contabilidad */}

                <Route path="/contabilidad/conciliacion/pagos" element={<Pagos />} />
                <Route path="/contabilidad/conciliacion/cuentas" element={<Cuentas />} />
                <Route path="/contabilidad/conciliacion/conciliacion-bancos" element={<ConciliarFacturas />} />


                <Route path="/contabilidad/activofijo" element={<ActivoFijo />} />
                <Route path="/contabilidad/activofijo/nuevo" element={<RegistroActivoFijo />} />
                <Route path="/contabilidad/activofijo/editar/:id" element={<RegistroActivoFijo />} />


                <Route path="/contabilidad/empleados/lista" element={<Empleados />} />
                <Route path="/contabilidad/empleados/vacaciones" element={<VacacionesPendientes />} />
                <Route path="/contabilidad/empleados/nuevo" element={<RegistroEmpleado />} />
                <Route path="/contabilidad/empleados/detalle/:id" element={<DetalleEmpleado />} />

                <Route path="/contabilidad/gastos" element={<Gastos />} />
                <Route path="/contabilidad/facturacion/Pagos-emitidos" element={<PagosEmitidos />} />
                <Route path="/contabilidad/facturacion/Ajustes" element={<AjustesFacturacion />} />
                <Route path="/contabilidad/facturacion/Modal/:idDatoFiscal" element={<ModalDatosFiscales />} />

                {/*<Route path="/contabilidad/facturacion/cargar-xml" element={<CargarXML />} />*/}
                {/* <Route path="/contabilidad/gastos" element={<Gastos />} />*/}
                {/*//<Route path="/contabilidad/Facturacion/cargar-xml" element={<CargarXML />} />*/}
                {/*//<Route path="/contabilidad/FacturasEmitidas" element={<Emitidas />} />*/}
                {/*//<Route path="/contabilidad/FacturasRecibidas" element={<Recibidas />} />*/}
                {/*<Route path="/contabilidad/facturacion/Ajustes" element={<AjustesFacturacion />} />*/}
                {/*<Route path="/contabilidad/configuracion/cuentas" element={<Cuentas />} />*/}



                <Route path="/contabilidad/empleados/nuevo" element={<RegistroEmpleado />} />
                <Route path="/contabilidad/empleados/detalle/:id" element={<DetalleEmpleado />} />
                <Route path="/contabilidad/Gastos" element={<Gastos />} />
                <Route path="/contabilidad/Impuestos" element={<Impuestos />} />


                {/*Contabilidad/facturacion */}
                <Route path="/contabilidad/facturacion/facturas" element={<Facturas />} />
                <Route path="/contabilidad/facturacion/formulario-factura?/:id" element={<FormularioFactura />} />
                <Route path="/contabilidad/facturacion/pagos-emitidos" element={<PagosEmitidos />} />
                <Route path="/contabilidad/facturacion/pagos-emitidos/FacturaPagoEmitido/:id" element={<VisualizacionFacturasPE />} />
                <Route path="/contabilidad/facturacion/pagos-recibidos" element={<PagosRecibidos />} />
                <Route path="/contabilidad/facturacion/pagos-recibidos/FacturaPagoRecibido/:id" element={<VisualizacionFacturasPR />} />
                <Route path="/contabilidad/facturacion/ajustes" element={<AjustesFacturacion />} />
                <Route path="/contabilidad/facturacion/cargar-xml" element={<CargarXML />} />
                <Route path="/contabilidad/facturacion/facturas-emitidas" element={<Emitidas />} />
                <Route path="/contabilidad/facturacion/facturas-emitidas/visualizacion/:id" element={<VisualizacionFacturasEmitidas />} />
                <Route path="/contabilidad/facturacion/facturas-recibidas" element={<Recibidas />} />
                <Route path="/contabilidad/facturacion/facturas-recibidas/visualizacion/:id" element={<VisualizacionFacturasRecibidas />} />
                <Route path="/contabilidad/facturacion/nomina" element={<Nominas />} />






                {/*Clientes */}
                <Route path="/clientes" element={<Clientes />} />

                <Route path="/clientes/detalle/:id" element={<DetallesCliente />} />
                <Route path="/clientes/nuevo" element={<NuevoCliente />} />
                <Route path="/clientes/informacionincompleta/:vFiltro" element={<ClientesInfoIncompleta />} />
                <Route path="/clientes/contactosduplicados/:vFiltro" element={<ConctactosDuplicados />} />

                {/*Distribuidores*/}
                <Route path="/distribuidores" element={<Distribuidores />} />

                {/* Ordenes */}
                <Route path="/ordenes/detalle/:id" element={<OrderDetails />} />
                <Route path="/ordenes/" element={<Orders />} />
                <Route path="/ordenes/nueva/:idClienteAkasia?/:idOrden?" element={<NuevaOrden />} />

                {/*Licencias*/}
                <Route path="/licencias/" element={<Licencias />} />
                <Route path="/licencias/detalle/:id" element={<DetallesLicencia />} />
                <Route path="/licencias/nueva/:idClienteAkasia?" element={<NuevaLicencia />} />
                <Route path="/licencias/nueva-servidor/:idClienteAkasia?" element={<NuevaLicenciaServidor />} />
                <Route path="/licencias/nueva-caja/:idClienteAkasia?" element={<NuevaLicenciaCaja />} />
                <Route path="/licencias/nueva-nube/:idClienteAkasia?" element={<NuevaLicenciaNube />} />
                <Route path="/licencias/nueva-app-comandas/:idClienteAkasia?" element={<NuevaAppComandas />} />
                <Route path="/licencias/nueva-akasiapos/:idClienteAkasia?" element={<NuevaLicenciaAkasiaPOS />} />
                <Route path="/licencias/informacionIncompleta/:vFiltro" element={<LicenciasInfoIncompleta />} />

                <Route path="/logservicios/logs" element={<LogServicios />} />

                <Route path="/polizas/detalle/:id" element={<DetallesPoliza />} />



                <Route path="/servicios/usuarios-nube-akasia/" element={<UsuariosNubeAkasia />} />
                <Route path="/servicios/usuarios-nube-akasia/nueva" element={<NuevoUsuarioNubeAkasia />} />
                <Route path="/servicios/usuarios-nube-akasia/editar/:id" element={<EditarUsuarioNubeAkasia />} />
                <Route path="/servicios/facturacion-ecuador" element={<FacturaDocumentosEcuador />} />
                <Route path="/servicios/facturacion-guatemala" element={<FacturaDocumentosGuatemala />} />
                <Route path="/servicios/facturacion-panama" element={<PlanesFacturacionPanama />} />
                <Route path="/servicios/facturacion-peru" element={<PlanesFacturacionPeru />} />
                <Route path="/servicios/facturacion-bolivia" element={<PlanesFacturacionBolivia />} />
                <Route path="/servicios/facturacion-elsalvador" element={<PlanesFacturacionElSalvador />} />
                <Route path="/servicios/facturacion-costarica" element={<PlanesFacturacionCostaRica />} />
                <Route path="/servicios/registro-taecel" element={<RecargasTaecel />} />

                {/* support desk */}

                <Route path="/soporte-tecnico/detalles-soporte/:id" element={<DetallesSoporte />} />


                <Route path="/productos/Catalogo" element={<Productos />} />
                <Route path="/productos/Nuevo" element={<AgregarProductos />} />
                <Route path="/productos/Detalle/:id" element={<DetalleProducto />} />


                {/* Metas de venta */}
                <Route path="/metas-de-venta/" element={<MetasVenta />} />
                <Route path="/perfil/:id?" element={<Profile />} />


                {/* Marketing */}

                <Route path="/marketing/calendario-editorial" element={<CalendarioEditorial />} />
                <Route path="/marketing/dashboard" element={<MarketingDashboard />} />

            </Route>


        </Routes>
    );
};

export default FalconRoutes;
